import React, { useEffect } from 'react';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { Button } from '@mui/material';
import { ApiManagementProps } from './ApiManagementContainer';
import TableSortLabel from '@mui/material/TableSortLabel';
import { ReactComponent as Download } from '../../assets/icons/download.svg';
import { ReactComponent as Warning } from '../../assets/icons/warning.svg';
import { ReactComponent as Success } from '../../assets/icons/success.svg';
import { openLinkInNewTab } from 'helpers/navigation';
import { API_PDF } from 'contracts/constants';
import {
  ActionsCell,
  AnimatedLoader,
  Card,
  ClickableText,
  Container,
  Header,
  HeaderTitle,
  StatusCell,
  Table,
  TableCell,
  TableHeader,
  TableHeaderTitle,
  TableRow,
} from './ApiManagement.styles';

const AccountManagement = ({
  certificate,
  isLoading,
  getCertificateDetailsRequest,
  createCertificateRequest,
  deleteCertificateRequest,
  getCertificateFileRequest,
  refreshCertificateRequest,
}: ApiManagementProps) => {
  const isExpired = () => {
    const now = new Date();
    return !!certificate && certificate.expirationDate < now;
  };

  const generate = () => {
    if (!!certificate && isExpired) {
      refreshCertificateRequest();
    } else if (!certificate) {
      createCertificateRequest();
    }
  };
  useEffect(() => {
    getCertificateDetailsRequest();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Container>
      <Header>
        <HeaderTitle>API Management</HeaderTitle>
        <Button
          onClick={generate}
          disabled={isLoading || (!!certificate && !isExpired())}
          startIcon={<AddIcon />}
          color="primary"
          variant="contained">
          Generate
        </Button>
        <Button
          onClick={() => deleteCertificateRequest()}
          disabled={isLoading || !certificate}
          startIcon={<DeleteIcon />}
          color="secondary"
          variant="contained">
          Delete
        </Button>
      </Header>
      <div style={{ margin: '15px' }}>
        <Card>
          <TableHeader>
            <TableHeaderTitle style={{ cursor: 'pointer' }}>
              Name
              <TableSortLabel></TableSortLabel>
            </TableHeaderTitle>
            <TableHeaderTitle style={{ cursor: 'pointer' }}>Thumbprint</TableHeaderTitle>
            <TableHeaderTitle style={{ cursor: 'pointer' }}>Status</TableHeaderTitle>
            <TableHeaderTitle>Expiration Date</TableHeaderTitle>
            <TableHeaderTitle>Actions</TableHeaderTitle>
          </TableHeader>
          <Table>
            {!!certificate && (
              <TableRow>
                <TableCell>{certificate.email}</TableCell>
                <TableCell title={certificate.thumbprint}>{certificate.thumbprint}</TableCell>
                {!isLoading && !isExpired() && (
                  <StatusCell>
                    <Success></Success>
                    <span style={{ color: '#1BB934' }}>Approved</span>
                  </StatusCell>
                )}
                {!isLoading && isExpired() && (
                  <StatusCell>
                    <Warning></Warning>
                    <span style={{ color: '#FF4081' }}>Expired</span>
                  </StatusCell>
                )}
                {isLoading && (
                  <StatusCell>
                    <AnimatedLoader></AnimatedLoader>
                    <span style={{ color: '#FFAB2B' }}>Waiting</span>
                  </StatusCell>
                )}
                <TableCell>{certificate.expirationDate.toLocaleString()}</TableCell>
                {!isExpired() && !isLoading && (
                  <ActionsCell>
                    <Download></Download>
                    <ClickableText onClick={() => getCertificateFileRequest()}>
                      Download certificate
                    </ClickableText>
                    <ClickableText onClick={() => openLinkInNewTab(API_PDF)}>
                      API documentation
                    </ClickableText>
                  </ActionsCell>
                )}
              </TableRow>
            )}
          </Table>
        </Card>
      </div>
    </Container>
  );
};

export default AccountManagement;
